import type { Printable } from './Printable';

export class Percent implements Printable {
  isGreaterOrEqualTo(max: Percent) {
    return max.value <= this.value;
  }

  private value: number;
  private constructor(value: number) {
    this.value = value;
  }

  static fromFloat(value: number) {
    return new Percent(value);
  }

  toString(options: Parameters<Printable['toString']>[0] = {}) {
    if (!isFinite(this.value)) return 'N/A';
    if (options.withUnit) return `${this._toTwoDigitsFloat()}%`;
    return this._toTwoDigitsFloat();
  }

  private _toTwoDigitsFloat() {
    return this.value.toFixed(2);
  }

  asFraction() {
    return this.value / 100;
  }

  toNumber() {
    return this.value;
  }
}
